// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__b3NDz","left":"InfoRow_left__dqcHk"};